
import { AssignmentStreamActivityRI } from 'common-utils/rest-interfaces';
import { pdsI18n } from '../pds-i18n';
import { NotificationItem } from './notification-item';

export type AsgmtReturnNotificationItemContext = {
  activity: AssignmentStreamActivityRI,
  userType: string,
  currentUserUid: string,
  getStreamGroupId: string,
  sectionName: string
};

export class AsgmtReturnNotificationItem extends NotificationItem {
  static NOTIFICATION_TYPE = 'ASSIGNMENT_NOTIFICATION';
  static NOTIFICATION_SUBTYPE = 'ASSIGNMENT_SUBMISSION_NOTIFICATION';

  static generateLookUpKey(assignmentUid: string): string {
    return [assignmentUid, AsgmtReturnNotificationItem.NOTIFICATION_TYPE].join(',');
  }

  constructor(isSeen = false, isRead = false, private context: AsgmtReturnNotificationItemContext) {
    super(AsgmtReturnNotificationItem.NOTIFICATION_TYPE, isSeen, isRead, undefined, AsgmtReturnNotificationItem.NOTIFICATION_SUBTYPE);

    this.id = this.context.activity.group || this.id; // if the activity doesn't have a group we use the generated id

    this.aggregationKey = JSON.stringify({
      assignmentUid: this.context.activity.assignmentUid
    });
  }

  getTitle(): string {
    return this.context.activity.assignmentName;
  }

  getSubtitle(): string {
    return this.context.activity.studentName;
  }

  getPostedAt(): Date | null {
    return new Date(this.context.activity.time + 'Z');
  }

  getUserType(): string {
    return this.context.userType;
  }

  getTooltip(): string {
    return pdsI18n.getText('pds|notifications|Student submitted homework');
  }

  getSenderUid(): string {
    return this.context.activity.studentUid;
  }

  getSectionUid(): string {
    return this.context.activity.sectionUid;
  }

  getSectionName(): string {
    return this.context.sectionName;
  }

  getColorClass(): string {
    return this.context.activity.assignmentCategoryColor;
  }

  get lookUpKey(): string {
    return AsgmtReturnNotificationItem.generateLookUpKey(this.context.activity.assignmentUid);
  }

  get currentUserUid(): string {
    return this.context.currentUserUid;
  }

  get getstreamGroupId(): string {
    return this.context.getStreamGroupId;
  }
}
